import { z } from 'zod';
import { GatewayConfigManifestComponentSchema, GatewayConfigManifestSchema, ApplyGatewayConfigCommandSchema, } from './gateway-config-manifest-schemas.js';
export const LocationReloadPolicySchema = z.enum(['none', 'engine-restart', 'orchestrator-hot']);
export const LocationManifestComponentSchema = GatewayConfigManifestComponentSchema.extend({
    reloadPolicy: LocationReloadPolicySchema,
    contentSha256: z.string(),
});
export const LocationGatewayManifestSchema = GatewayConfigManifestSchema.extend({
    gatewayType: z.literal('location').optional(),
    presignedUrlExpiresAt: z.string().datetime(),
    pushedBy: z.object({
        userId: z.string(),
        email: z.string().email().or(z.literal('')),
    }),
    components: z.record(z.string(), LocationManifestComponentSchema),
});
export const ApplyLocationGatewayConfigPayloadSchema = ApplyGatewayConfigCommandSchema.extend({
    manifestKey: z.string(),
});
//# sourceMappingURL=location-gateway-config-schemas.js.map